export default __webpack_public_path__ + "static/media/xtra_banner.267c9738.svg";